// extracted by mini-css-extract-plugin
export default {"container":"Wallet_container__wCUwf","main":"Wallet_main__VQ6jT","body":"Wallet_body__JO-S9"};